import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7AA13CBC-D472-4462-8263-88DA2BDCD6BB
 * name pause-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-circle.svg
 * tags
 */
export const PauseCircleIcon = createSvgIcon(<><path d="M15,16H13V8H15M11,16H9V8H11M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'PauseCircleIcon');
export default PauseCircleIcon